import Vue from 'vue';

import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    allFaqReportZipFileDetail: [],
    allActiveFaqReportZipFileDetail: []
  },
  getters: {
    allFaqReportZipFileDetail: (state) => state.allFaqReportZipFileDetail,
    allActiveFaqReportZipFileDetail: (state) => state.allActiveFaqReportZipFileDetail
  },
  actions: {
    loadAllFaqReportZipFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllFaqReportZipFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllFaqReportZipFileDetail', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadAllActiveFaqReportZipFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllActiveFaqReportZipFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllActiveFaqReportZipFileDetail', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

  },
  mutations: {
    setAllFaqReportZipFileDetail(state, data) {
      Vue.set(state, 'allFaqReportZipFileDetail', data);
    },
    setAllActiveFaqReportZipFileDetail(state, data) {
      Vue.set(state, 'allActiveFaqReportZipFileDetail', data);
    }
  },
};
